module.exports = __webpack_public_path__ + "./eric-illustration_db5bc72546342bbf751d91079ca294ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2014/eric-illustration.png
// module id = 412
// module chunks = 0